import { jsx as _jsx } from "react/jsx-runtime";
import { getAddress } from "../../../../../../utils/address.js";
import { TokenIcon } from "../../../components/TokenIcon.js";
import { isNativeToken } from "../nativeToken.js";
import { useBuySupportedDestinations } from "./swap/useSwapSupportedChains.js";
// This is a temporary solution to get the token icon working for ERC20 tokens
// TODO: The proper solutioon is to include the token icon in the quotes / status response objects, currently it is missing.
export function PayTokenIcon(props) {
    const supportedDestinationsQuery = useBuySupportedDestinations(props.client);
    const token = props.token;
    const tokenIcon = !isNativeToken(token)
        ? supportedDestinationsQuery.data
            ?.find((c) => c.chain.id === props.chain.id)
            ?.tokens.find((t) => getAddress(t.address) === getAddress(token.address))?.icon
        : undefined;
    return (_jsx(TokenIcon, { token: isNativeToken(token)
            ? { nativeToken: true }
            : {
                address: token.address,
                icon: token.icon || tokenIcon,
            }, chain: props.chain, client: props.client, size: props.size }));
}
//# sourceMappingURL=PayTokenIcon.js.map